// extracted by mini-css-extract-plugin
module.exports =  {"root":"NoshLUENTO4pImertLF4","left":"xmYneaOoRJFveG_WiK9v","right":"en51aXNLz2SzLyfaEdVH","ageDemographics":"kQ1nbW8o3DkwhY3MVap0","description":"doc04ygxlbVk3TsZQnYu"};